import { useEffect, useRef, useState } from "react";
import { useProducts } from "../../context/ProductsContext";
import { icons } from "../../const/icons";
import { Input } from "antd";
import "./ProductSearchBar.css";
import { useProductOperations } from "../../hooks/inventario/useProductOperations";
import { useStores } from "../../context/StoresContext";

/**
 * Barra de búsqueda de productos.
 */
export const ProductSearchBar = () => {
  const { searchTerm, setSearchTerm } = useProducts();
  const { stores, setSelectedStore, setSelectedStoreData } = useStores();
  const { operations: productOperations, states: productStates } = useProductOperations();
  const [localTerm, setLocalTerm] = useState(searchTerm);
  const inputRef = useRef(null);

  //* Sincronizar localTerm con searchTerm global
  useEffect(() => {
    setLocalTerm(searchTerm);
  }, [searchTerm]);

  const handleChange = (e) => {
    const value = e.target.value;
    const trimmedValue = value.trim();

    setLocalTerm(trimmedValue);

    if (trimmedValue === "" && searchTerm !== "") {
      handleClearSearch();
    }
  };

  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const trimmedTerm = localTerm.trim();

      if (trimmedTerm === "") {
        await handleClearSearch();
        return;
      }

      setSearchTerm(trimmedTerm);

      // Cambiar a "Todos" automáticamente
      const todosStore = stores.find((s) => s.id === 0);
      if (todosStore) {
        setSelectedStore("Todos");
        setSelectedStoreData(todosStore);
      }

      const res = await productOperations.searchProducts(trimmedTerm);

      if (res?.error) {
        return;
      }

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
    }

    if (e.key === "Escape") {
      await handleClearSearch();

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
    }
  };

  const handleClearSearch = async () => {
    setLocalTerm("");
    setSearchTerm("");

    // Mantener "Todos" pero traer todos los productos
    const todosStore = stores.find((s) => s.id === 0);
    if (todosStore) {
      setSelectedStore("Todos");
      setSelectedStoreData(todosStore);
    }

    // Traer todos los productos (sin filtro de búsqueda)
    await productOperations.fetchProducts({ page: 0, size: 10 });
  };

  const handleClear = async () => {
    await handleClearSearch();

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  };

  return (
    <Input
      ref={inputRef}
      value={localTerm}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder="Buscar producto"
      prefix={<img src={icons.search} alt="Buscar producto" className="search-img" />}
      allowClear
      onClear={handleClear}
      disabled={productStates.fetchState.loading}
      className="product-search-input"
      style={{
        width: 280,
        background: "#fff",
      }}
    />
  );
};
